export const convertSort = (sort: Record<string, 'asc' | 'desc'>): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const key in sort) {
    result[key] = sort[key] === 'asc' ? key : `-${key}`;
  }
  return result;
};
